import Image from "next/image";
import { cn } from "../../lib/utils";
import { HEADSHOT_SHAPE_CLASS } from "./headshot-shape";
import { initialsFor } from "./shared";

type Props = {
	src: string | null;
	firstName: string;
	lastName: string;
	/** Intrinsic pixel size for next/image (width and height). */
	size: number;
	/** Size + shape classes shared by the image and the initials tile. */
	className?: string;
	/** Initials tile only: type scale overrides. */
	fallbackClassName?: string;
};

/**
 * Directory-card headshot: the profile picture, or a forest gradient tile with
 * the therapist's initials when there is none.
 */
export const DirectoryHeadshot = ({
	src,
	firstName,
	lastName,
	size,
	className = HEADSHOT_SHAPE_CLASS,
	fallbackClassName,
}: Props) => {
	if (src) {
		// No `sizes` on purpose: a fixed-pixel box with a px-only `sizes` makes
		// Next emit the full deviceSizes ladder; omitting it emits a 1x/2x srcset.
		return (
			<Image
				src={src}
				alt={[firstName, lastName].filter(Boolean).join(" ")}
				width={size}
				height={size}
				className={className}
			/>
		);
	}
	return (
		<div
			className={cn(
				"flex items-center justify-center bg-linear-to-br from-klarify-forest-100 to-klarify-forest-300 font-semibold text-klarify-forest-800 tracking-tight",
				className,
				fallbackClassName,
			)}
		>
			{initialsFor(firstName, lastName)}
		</div>
	);
};

DirectoryHeadshot.displayName = "DirectoryHeadshot";
